export const notificationDrawer = {
  notificationDrawerTitle: "Notificaciones",
  notificationDrawerDeleteBtn: "Eliminar",
  notificationDrawerDeletedNotification: "Notificación eliminada",
  notificationDrawerDeletedFailed: "Eliminar notificación falló",
  notificationMarkReadFailed: "Marcar notificación como leída falló",
  notificationDrawerNotifications: "Sin notificaciones",
  notificationDrawerPlay: "Jugar",
  notificationDrawerPlayGame: "Ir al juego",
  notificationClose: "Cerrar",
  notificationJustNow: "Ahora",
  notificationMarkRead: "Marcar como leída",
  notificationTagNews: "Noticia",
  notificationTagPush: "Aviso",
  notificationTagBreaking: "Promos y más",
  notificationTagMovement: "Movimiento",
  notificationTab_all: "Todo",
  notificationTab_news: "Noticias",
  notificationTab_breaking: "Promos y más",
  notificationTab_movements: "Movimientos",
  notificationEmptySubtext: "Cuando tengas nuevas notificaciones aparecerán aquí",
  notificationNewsCta: "Haz clic para saber más",
};
